<!-- Backdrop -->
<div class="modal-backdrop fade show" *ngIf="visible"></div>

<!-- Modal -->
<div
  *ngIf="visible"
  class="modal fade show d-block"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="onCancel()"></button>
      </div>

      <div class="modal-body d-grid gap-2">
        <don-checkout-summary
          *ngIf="summaryVm"
          [vm]="summaryVm"
          (vmChange)="onSummaryVmChange($event)">
        </don-checkout-summary>
      </div>

      <div class="modal-footer d-flex align-items-center justify-content-between">
        <button type="button" class="btn btn-use-another-card" (click)="onUseAnotherCard()">
          Otra tarjeta
        </button>
        <div class="d-flex align-items-center justify-content-end gap-3">
          <button type="button" class="btn btn-outline-crezco" (click)="onCancel()">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-crezco-primary"
            [disabled]="!summaryVm?.hasCalculatedFees || !!summaryVm?.isCalculatingFees"
            (click)="onAccept()">
            Continuar
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
